import {
  Component,
  AfterViewInit,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  PLATFORM_ID,
  Inject,
  inject,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../components/loader/loader.component';
import { LoaderService } from '../../Services/loader-service.service';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { ApiCallService } from '../../Services/api-call-service.service';
import { ApiPayloadService } from '../../Services/api-payload-service.service';
import { WebSocketService } from '../../Services/web-socket.service';
import { register } from 'swiper/element/bundle';
import { Slide } from '../../Interfaces/interfaces';
import { CookieService } from 'ngx-cookie-service';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { NotificationService } from '../../Services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from '../../Services/modal.service';
import { MusicService } from '../../Services/music.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SignUpPopUpComponent } from '../signup/sign-up-pop-up/sign-up-pop-up.component';
import { FirebaseService } from '../../Services/firebase.service';
import { DeviceIdService } from '../../Services/device-id.service';

declare let fbq: Function;

@Component({
  selector: 'app-login',
  standalone: true,
  styleUrls: ['./login.component.scss'],
  imports: [
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    LoaderComponent,
    FontAwesomeModule,
    CarouselModule,
  ],
  templateUrl: './login.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  private modalService = inject(ModalService);
  loginForm: FormGroup;
  errorMessage: string | null = null;
  googleAccesToken: string = '';
  redirectState: string | null = '';
  showpassword: boolean = false;
  showicon = faEye;
  hideicon = faEyeSlash;
  @Input() isPopup = false;
  @Output() closed = new EventEmitter<void>();
  @Output() forgotPasswordRequested = new EventEmitter<void>();
  @Output() signUpRequested = new EventEmitter<void>();
  private readonly _route: ActivatedRoute = inject(ActivatedRoute);


  constructor(
    private fb: FormBuilder,
    private apiCallService: ApiCallService,
    private router: Router,
    private apiPayloadService: ApiPayloadService,
    private toastr: ToastrService,
    public loaderService: LoaderService,
    private handleError: ErrorhandlingService,
    private _socketService: WebSocketService,
    private cookieService: CookieService,
    private notificationService: NotificationService,
    private _firebaseService: FirebaseService,
    @Inject(PLATFORM_ID) private platformId: object,
    private activatedRoute: ActivatedRoute,
    private musicService: MusicService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
        private DeviceIdService: DeviceIdService,
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      userPassword: ['', Validators.required],
      fcm: [''],
      deviceUId: [''],
      rememberMe: [false],
    });
    register();

    this.isBrowser = isPlatformBrowser(this.platformId);

    this._route.fragment.subscribe((fragment) => {
      if (fragment) {
        const params = new URLSearchParams(fragment);
        const accessToken = params.get('id_token');
        const redirectState = params.get('state');
        if (accessToken) {
          this.googleAccesToken = accessToken;
          this.redirectState = redirectState;
          this.VerfiyGoogleUser(accessToken);
        }
        // Remove the fragment from the URL (without reloading)
        this.router.navigate([], {
          relativeTo: this._route,
          replaceUrl: true,
          fragment: undefined,
        });
      }
    });
  }

  isBrowser: boolean;
  ngOnInit(): void {
    //     this.loaderService.show(); // Show loader immediately
    // setTimeout(() => {
    //   this.loaderService.hide(); // Hide loader after 2 seconds
    // }, 1000);
    const savedUsername = this.cookieService.get('rememberedUsername');
    const rememberMeStatus = this.cookieService.get('rememberMe') === 'true';

    if (rememberMeStatus && savedUsername) {
      this.loginForm.patchValue({
        username: savedUsername,
        rememberMe: true,
      });
    }
  }

  togglePassword() {
    this.showpassword = !this.showpassword;
  }

  getDeviceOS(): 'iOS' | 'Android' | 'Desktop' {
    if (typeof window === 'undefined') return 'Desktop';

    const ua = navigator.userAgent || navigator.vendor;

    if (/android/i.test(ua)) {
      return 'Android';
    }

    if (
      /iPad|iPhone|iPod/i.test(ua) ||
      (ua.includes('Mac') && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS';
    }

    return 'Desktop';
  }
  async loginUser() {
    if (this.loginForm.valid) {
      const os = this.getDeviceOS();
      var fcmToken;
      if (os !== 'iOS') {
        fcmToken = await this._firebaseService.init();
      }
      // generate random 3 alphabets and 3 digits and store in deviceUId
      const letters = Array.from({ length: 3 }, () =>
        String.fromCharCode(97 + Math.floor(Math.random() * 26)),
      ).join('');
      const digits = (Math.floor(Math.random() * 900) + 100).toString(); // ensures 3 digits
      const deviceId = `${letters}${digits}`;
      if (fcmToken) {
        this.loginForm.patchValue({ deviceUId: deviceId, fcm: fcmToken });
      } else {
        this.loginForm.patchValue({ deviceUId: deviceId });
      }

      this.loaderService.show();
      const loginData = this.apiPayloadService.createLoginUserPayload(
        this.loginForm.value,
      );
      this.apiCallService
        .PostCallWithoutToken(loginData, 'User/LoginUser')
        .subscribe(
          (response) => {
            this.loaderService.hide();
            if (response && response.responseCode === 200) {
              // console.log('User logged in successfully', response);
              // Check if user type is customer
              if (response.data.userType !== 'customer') {
                this.loaderService.hide();
                this.toastr.warning('You must login with a customer role');
                return;
              }
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('code', response.data.refferCode);
              localStorage.setItem('userType', response.data.userType);
              localStorage.setItem(
                'isTempPassword',
                response.data.isTempPassword?.toString(),
              );
              localStorage.setItem(
                'isMobileUser',
                response.data.isMobileUser?.toString(),
              );
              localStorage.setItem(
                'clientId',
                response.data.clientId?.toString(),
              );
              localStorage.setItem(
                'isMultiClientExist',
                response.data.isMultiClientExist?.toString(),
              );
              localStorage.setItem('userId', response.data.userId?.toString());
              localStorage.setItem('email', response.data.email);
              localStorage.setItem(
                'customerId',
                response.data.customerId.toString(),
              );
              localStorage.setItem('deviceUId', response.data.deviceUId);
              localStorage.setItem('panelType', response.data.panelType);
              // this.apiCallService.GetCallWithToken('NotificationMessages/GetAllNotifications?PageNumber=1&PageSize=10')
              //           .subscribe((notifResponse) => {
              //             if (notifResponse && notifResponse.responseCode === 200) {
              //               localStorage.setItem('notifications', JSON.stringify(notifResponse.data));
              //             }
              //             // You may want to handle errors here
              //           });
              this.notificationService.loadNotifications(true);

              // Save username in cookies if "Remember Me" is checked
              if (this.loginForm.value.rememberMe) {
                this.cookieService.set(
                  'rememberedUsername',
                  this.loginForm.value.username,
                  { expires: 360, path: '/' },
                );
                this.cookieService.set('rememberMe', 'true', {
                  expires: 360,
                  path: '/',
                });
              } else {
                // Clear cookies if "Remember Me" is unchecked
                this.cookieService.delete('rememberedUsername', '/');
                this.cookieService.delete('rememberMe', '/');
              }

              if (this._socketService.isConnected == false) {
                this._socketService.connect();
              }
              this.loaderService.triggerFunction();
              this.loaderService.triggerWalletFunction();
              const redirectUrl =
                this.activatedRoute.snapshot.queryParams['redirectUrl'];
              if (redirectUrl) {
                this.router.navigateByUrl(redirectUrl);
              } else {
                // this.fireLeadPixel(response.data.isAlreadyLoggedIn);
                this.openFreeSpin(response.data.isAlreadyLoggedIn);
                this.router.navigate(['/dashboard/home']);
              }
            } else if (
              response?.responseCode === 400 &&
              response?.errorMessage ==
                'Please verify your email before logging in.'
            ) {
              this.handleError?.showAlert(
                'warning',
                'A code was already sent to your email. Enter it or resend.',
              );
              const dialogRef = this.openPopup(false, response?.data);
              dialogRef.afterClosed().subscribe(() => {
                // Navigate to login after popup closes
                // this.router.navigate(['/login']);
              });
            } else {
              this.handleError.handleResponseError(response);
              this.loaderService.hide();
            }
          },
          (error) => {
            this.handleError.handleHttpError(error);
            this.loaderService.hide();
          },
        );
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  showFreeSpinPromotionalMessage() {
    this.modalService.showPopup({
      title: 'Free Spin Available!',
      message:
        'You have a free spin waiting for you. Spin the wheel now to win exciting prizes!',
      image: '/Images/spinner.png',
      buttonText: 'Spin Now',
      // buttonText2: 'Later',
      path: '/dashboard/spinner',
    });
  }

  slides: Slide[] = [
    {
      id: 1,
      uniqueId: 'slide-1',
      src: '/Images/landing_1.png',
      heading: 'Welcome Back!',
      content: 'Log in to continue your journey with Casinoze.',
    },
    {
      id: 2,
      uniqueId: 'slide-2',
      src: '/Images/landing_2.png',
      heading: 'Exciting Games!',
      content: 'Enjoy a variety of exciting casino games and win big!',
    },
    {
      id: 3,
      uniqueId: 'slide-3',
      src: '/Images/landing_3.png',
      heading: 'Secure Transactions!',
      content:
        'Experience fast and secure transactions for a seamless gaming experience.',
    },
  ];

  trackByFn(index: number, slide: any): string {
    return `${slide.uniqueId}-${index}`;
  }
  isScreenWidthLessThan800(): boolean {
    return window.innerWidth < 800;
  }

  continueWithGoogle(event: Event) {
    event.stopPropagation();

    const clientId =
      '996395306309-6amafcbh3p6faflbmhgmfa4ish1vt3b6.apps.googleusercontent.com';
    const redirectUri = 'https://highrollers.game/login';
    const responseType = 'id_token';
    const scope = 'openid email profile';
    const nonce = this.generateNonce();
    const customRedirect =
      this.activatedRoute.snapshot.queryParams['redirectUrl'];

    const googleOAuthUrl =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?client_id=${clientId}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_type=${responseType}` +
      `&scope=${encodeURIComponent(scope)}` +
      `&nonce=${nonce}` +
      `&state=${encodeURIComponent(customRedirect)}`;

    // window.location.href = googleOAuthUrl;
    // Show loader briefly before redirecting so user sees feedback
    try {
      this.loaderService.show();
    } catch (e) {
      // ignore if loader service isn't available
    }
    setTimeout(() => {
      try {
        this.loaderService.hide();
      } catch (e) {
        // ignore
      }
      window.location.href = googleOAuthUrl;
    }, 1000);
  }

  generateNonce() {
    return Math.random().toString(36).substring(2);
  }

 async VerfiyGoogleUser(token: string) {
    this.loaderService.show();

    const referralCode = sessionStorage.getItem('referralCode');
    const adCode = sessionStorage.getItem('adCode');

   const deviceId = await this.DeviceIdService.getDeviceId();
  const deviceFingerprint = await this.DeviceIdService.getDeviceFingerprint();


  // 2. Base URL banayein jismein token aur dono compulsory parameters pehle se hon
  let apiUrl = `User/ContinueWithGoogle?idToken=${encodeURIComponent(token)}` +
               `&deviceId=${encodeURIComponent(deviceId || '')}` +
               `&deviceFingerprint=${encodeURIComponent(deviceFingerprint || '')}`;

    if (referralCode) {
      apiUrl += `&RefferCode=${referralCode}`;
    }
    if (adCode) {
  apiUrl += `&ad=${adCode}`; 
   }

console.log('Final API URL:', apiUrl);
    this.apiCallService.PostCallWithoutToken(null, apiUrl).subscribe(
      (response) => {
        // handle 400 response early
        if (response && response.responseCode === 400) {
          this.loaderService.hide();
          this.toastr.warning(
            'Something went wrong. Please try again after some time.',
          );
          return;
        }

        if (
          response.responseCode == 200 &&
          response.responseMessage != 'Account Created Successfully'
        ) {
          this.loaderService.hide();
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('code', response.data.refferCode);
          localStorage.setItem('userType', response.data.userType);
          localStorage.setItem(
            'isTempPassword',
            response.data.isTempPassword?.toString(),
          );
          localStorage.setItem(
            'isMobileUser',
            response.data.isMobileUser?.toString(),
          );
          localStorage.setItem('clientId', response.data.clientId?.toString());
          localStorage.setItem(
            'isMultiClientExist',
            response.data.isMultiClientExist?.toString(),
          );
          localStorage.setItem('userId', response.data.userId?.toString());
          localStorage.setItem('email', response.data.email);
          localStorage.setItem(
            'customerId',
            response.data.customerId.toString(),
          );
          localStorage.setItem('deviceUId', response.data.deviceUId);
          localStorage.setItem('panelType', response.data.panelType);
          this.notificationService.loadNotifications(true);
        } else {
          this.cookieService.delete('rememberedUsername', '/');
          this.cookieService.delete('rememberMe', '/');
        }

        if (response.responseMessage == 'Account Created Successfully') {
          this.VerfiyGoogleUser(this.googleAccesToken);
        } else {
          if (this._socketService.isConnected == false) {
            this._socketService.connect();
          }
          this.loaderService.triggerFunction();
          this.loaderService.triggerWalletFunction();
          const redirectUrl = this.redirectState;
          if (redirectUrl) {
            this.fireLeadPixel(response.data.isAlreadyLoggedIn);
            this.router.navigateByUrl(redirectUrl);
          } else {
            this.fireLeadPixel(response.data.isAlreadyLoggedIn);
            this.router.navigate(['/dashboard/home']);
          }
        }
      },
      (error) => {
        this.handleError.handleHttpError(error);
        this.loaderService.hide();
      },
    );
  }
  fireLeadPixel(isFirstTime: number) {
    if (this.isBrowser && isFirstTime === 0 && typeof fbq === 'function') {
      fbq('track', 'Lead');
      console.log('Lead pixel fired');
      setTimeout(() => {
        this.showFreeSpinPromotionalMessage();
      }, 3000);
    }
  }
  openFreeSpin(isFirstTime: number) {
    if (isFirstTime === 0) {
      setTimeout(() => {
        this.showFreeSpinPromotionalMessage();
      }, 3000);
    }
  }
  // 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
  // 57908406230-sdn537q1kjg6rh299egrdonqkmjggt57.apps.googleusercontent.com

  // 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
  // 996395306309-6amafcbh3p6faflbmhgmfa4ish1vt3b6.apps.googleusercontent.com

  // Play Stop Music

  startMusicOnce = () => {
    this.startMusic();
    this.removeInteractionListeners();
  };

  removeInteractionListeners() {
    document.removeEventListener('mousemove', this.startMusicOnce);
    document.removeEventListener('scroll', this.startMusicOnce);
    document.removeEventListener('click', this.startMusicOnce);
  }

  ngOnDestroy() {
    this.removeInteractionListeners();
  }

  startMusic() {
    this.musicService.playMusic();
  }

  toggleMusic() {
    this.musicService.muteUnmute();
  }

  closeLogin() {
    if (this.isPopup) {
      this.closed.emit();
    } else {
      this.router.navigate(['/']);
    }
  }

  requestForgotPassword(event: Event) {
    event.preventDefault();
    if (this.isPopup) {
      this.forgotPasswordRequested.emit();
    } else {
      this.router.navigate(['/ForgotPassword']);
    }
  }

  requestSignUp(event: Event) {
    event.preventDefault();
    if (this.isPopup) {
      this.signUpRequested.emit();
    } else {
      this.router.navigate(['/SignUp']);
    }
  }

  get isMusicMuted(): boolean {
    return this.musicService.isMusicMuted();
  }
  openPopup(
    isGoogleLogin: boolean = false,
    data: any = null,
  ): MatDialogRef<SignUpPopUpComponent> {
    const email = data;
    const dialogRef = this.dialog?.open(SignUpPopUpComponent, {
      width: '400px',
      disableClose: true,
      data: { email, isGoogleLogin },
    });

    // Hide overflow on body to prevent scrolling issues
    if (this.window) {
      this.window.document.body.style.overflow = 'hidden';
    }

    setTimeout(() => this.cdr.detectChanges()); // Ensure UI updates

    dialogRef.afterClosed().subscribe(() => {
      if (this.window) {
        this.window.document.body.style.overflow = ''; // Restore overflow
      }
    });

    return dialogRef;
  }
  window: Window | null = null;
}
